import React from "react";
import { ArrowRight } from "lucide-react";
import { offer } from "../data";

// Порядок блоков задан под то, как человек читает первый экран:
// что это → сколько стоит → как выглядит → почему здесь → записаться.
// Кнопка намеренно в конце: пока посетитель не понял предложение,
// записываться он не станет.
//
// На десктопе фото уходит в правую колонку, а текст с кнопкой остаются
// слева; на телефоне всё выстраивается в одну колонку в том же порядке.
// Раскладка — через grid-template-areas в App.css (.hero-grid).
export default function Hero() {
  return (
    <section className="hero" id="hero">
      <div className="container">
        <div className="hero-grid fade-in">
          <h1 className="hero-title">Имплантация зубов в Ярославле</h1>

          <p className="hero-offer">
            Готовый зуб «под ключ» <span className="hero-offer-price">за {offer.turnkeyFrom} ₽</span>
          </p>

          <div className="hero-visual">
            <div className="hero-photo">
              <img
                src="/clinic/microscope.jpg"
                alt="Врач работает с операционным микроскопом"
                loading="eager"
              />
            </div>
          </div>

          <div className="hero-about">
            <p className="hero-subtitle">
              Опытные врачи, новейшее оборудование, беспроцентная рассрочка и пожизненная гарантия на имплант.
            </p>

            <div className="hero-proof">
              <div className="hero-proof-item">
                <div className="hp-num">15+</div>
                <div className="hp-txt">лет опыта врачей-имплантологов</div>
              </div>
              <div className="hero-proof-item">
                <div className="hp-num">∞</div>
                <div className="hp-txt">пожизненная гарантия на имплант</div>
              </div>
              <div className="hero-proof-item">
                <div className="hp-num">0%</div>
                <div className="hp-txt">рассрочка до 24 месяцев</div>
              </div>
            </div>
          </div>

          <div className="hero-cta-row">
            <a href="#final" className="btn btn-primary" data-testid="hero-cta-primary">
              Записаться на консультацию
              <ArrowRight size={18} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
